module.exports = __webpack_public_path__ + "img/paperplane.7ae73079.svg";